// extracted by mini-css-extract-plugin
export default {"learningPaths":"LearningPaths_learningPaths__4hNsR","learningPathCard":"LearningPaths_learningPathCard__p3tAA"};